<template>
  <div>
    <el-dialog
      :center="true"
      :visible.sync="show"
      :close-on-click-modal="false"
      width="500px"
      class="addNewAppDialog"
    >
      <div class="a-d-top">
        <div class="a-d-topTit">
          <div>{{ lang.select_app }}</div>
        </div>
        <div class="a-d-t-right">
          <span @click="close()">×</span>
        </div>
      </div>
      <div class="box" v-loading="loading">
        <div class="b_search">
          <el-input
              v-model="search"
              style="margin-right: 10px;"
              :placeholder="lang.input_app_name"
              @keyup.enter.native="getData"
            >
            <i
                slot="suffix"
                class="searchInputIcon el-icon-search"
                @click="getData"
              ></i>
          </el-input>
        </div>

        <div class="b_list">
          <div class="b_l_item" v-for="item in dataList" :key="item.id" @click="choseItem(item)">
            <div class="b_l_i_icon">
              <img v-if="item.json.icon" :src="item.json.icon" />
              <svg
                v-else
                t="1732605901531"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4275"
                width="200"
                height="200"
              >
                <path
                  d="M179.2 153.6a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V204.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V204.8a153.6 153.6 0 0 1 153.6-153.6z m0 614.4a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V716.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V716.8a153.6 153.6 0 0 1 153.6-153.6z m611.84-403.4048a51.2 51.2 0 0 0-72.3968 0L646.144 232.2432a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968L791.04 159.744z m72.3968-72.3968l72.3968 72.3968a153.6 153.6 0 0 1 0 217.2416l-72.3968 72.3968a153.6 153.6 0 0 1-217.2416 0l-72.3968-72.3968a153.6 153.6 0 0 1 0-217.2416l72.3968-72.3968a153.6 153.6 0 0 1 217.2416 0zM699.7504 896a51.2 51.2 0 0 1 0 102.4A162.1504 162.1504 0 0 1 537.6 836.2496v-110.8992A162.1504 162.1504 0 0 1 699.7504 563.2h110.8992a162.1504 162.1504 0 0 1 162.1504 162.1504v8.448a51.2 51.2 0 0 1-102.4 0v-8.448c0-33.024-26.7264-59.7504-59.7504-59.7504h-110.8992c-33.024 0-59.7504 26.7264-59.7504 59.7504v110.8992c0 33.024 26.7264 59.7504 59.7504 59.7504z"
                  fill="#2C6DD2"
                  p-id="4276"
                ></path>
                <path
                  d="M791.4496 160a51.2 51.2 0 0 0-72.3968 0l-72.448 72.3968a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968l-72.3968-72.3968z"
                  fill="#20C997"
                  p-id="4277"
                ></path>
              </svg>
            </div>
            <div class="b_l_i_message">
              <div>{{ item.name }}</div>
              <span>{{ item.detail }}</span>
            </div>
          </div>
        </div>

      </div>
      <div class="box_bottom">
        <el-button @click="close()">{{ lang.cancel }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
		userId: String,
		org: String,
		oid: String,
		region: {
			type: String,
			default: "cn",
		},
  },
  data() {
    return {
      loading: false,
      show: false,
      search:'',
      dataList:[],
    };
  },
  watch:{
    search:{
      immediate:false,
      handler(){
        if(this.search===""){
          this.getData();
        }
      }
    }
  },
  methods: {
    open() {
      this.dataList = [];
      this.search = ""
      this.loading = false;
      this.getData();
      this.show = true;
    },
    close() {
      this.show = false;
      this.init();
    },
    init() {
      this.search = ""
      this.loading = false;
      this.dataList = [];
    },
    getData() {
      this.loading = true;
      let params = {
        uid: this.userId, //用户ID
        name: this.search, //应用名称搜索
        label: "", //应用的标签搜索
        type: "", //应用的类型
        juri: 99, //应用权限 1:我的  2：组织内  3：所有人   99：未发布
        stand: this.region?this.region:'cn', //cn站还是hk站
        status:''
      };

      this.ajax
        .get(this.$store.state.api + "select_appStore", params)
        .then(res => {
          let _data = res.data[0];
          if (_data.length > 0) {
            _data.forEach(i => {
              if (i.json) {
                i.json = JSON.parse(i.json);
              }
            });
            this.dataList = _data;
          } else {
            this.dataList = [];
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.$message.error("获取应用失败");
        });
    },
    choseItem(item){
      this.$emit("success",item)
    }
  }
};
</script>

<style scoped>
.addNewAppDialog >>> .el-dialog {
  min-width: 500px;

  height: 700px;
	/* height: 780px; */
  box-shadow: 0px 0 8px 0px #555555;
  border-radius: 8px;
  background-color: #fff;
  /* top: 0px; */
  /* margin: 0 auto; */
  overflow: hidden;
}
.addNewAppDialog >>> .el-dialog__body {
  height: 100%;
  min-width: 500px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding-bottom: 50px;
  padding-top: 10px;
}
.addNewAppDialog >>> .el-dialog__header {
  display: none !important;
}

.a-d-top {
  /* background: #adadad; */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  border-radius: 8px 8px 0 0;
  user-select: none;
  border-bottom: 1px #ccc solid;
}
.a-d-top >>> .el-input__inner {
  width: 320px;
  height: 32px;
}
.a-d-top >>> .el-input__icon {
  line-height: 32px;
}

.a-d-topTit {
  /* width: 171px; */
  /* margin-left: 20px; */
  height: 32px;
  display: flex;
  font-weight: bold;
  font-size: 20px;
  align-items: center;
  font-family: PingFang SC;
  box-sizing: border-box;
  padding: 5px;
  line-height: 22px;
  justify-content: center;
  /* text-align: left; */
}

.a-d-t-right > span {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.box{
  width: 100%;
  height: calc(100% - 60px - 20px);
  display: flex;
  flex-direction: column;
}

.box_bottom{
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.b_search{
  display: flex;
  height: 40px;
  margin-top: 10px;
}

.b_list{
  width: 100%;
  height: calc(100% - 40px);
  overflow: auto;
  box-sizing: border-box;
  padding: 10px 0 10px 0;
}

.b_l_item{
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  background-color: #fff;
  transition: .2s;
  border-radius: 4px;
  cursor: pointer;
}

.b_l_item:hover{
  background-color: #f2f4f7;
}

.b_l_item:hover .b_l_i_message>div{
  color: #0354D7;
}

.b_l_item:hover .b_l_i_message>span{
  color: #000000B8;
}

.b_l_i_icon{
  width: 80px;
  height: 80px;
  margin-left: 10px;
  box-sizing: border-box;
  padding: 5px;
  margin-right: 10px;
}

.b_l_i_icon>img{
  width: 100%;
  height: 100%;
  border: 1px solid #E7E7E7;
  border-radius: 4px;
}

.b_l_i_icon>svg{
  width: 100%;
  height: 100%;
  border: 1px solid #E7E7E7;
  border-radius: 4px;
}

.b_l_i_message{
  width: calc(100% - 100px);
  height: 80px;
  box-sizing: border-box;
  padding: 10px 0;
}

.b_l_i_message>div{
  transition: .2s;
  font-size: 1.4em;
  color: #000;
  /* font-weight: bold; */
}

.b_l_i_message>span{
  font-size: 1.2em;
  margin-top: 15px;
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.searchInputIcon {
  width: 20px;
  height: 20px;
  position: relative;
  top: 10px;
  right: 5px;
  font-size: 19px;
  cursor: pointer;
  color: #666666;
}
</style>
